import React from 'react';
/**
 * DjayAvatar part — arms per emotion (with small-size stubs fallback).
 * Verbatim extraction of the former `renderArms()`.
 */
import type { DjayEmotion, VariantColorScheme } from '../types';
interface ArmsProps {
  emotion: DjayEmotion;
  colors: VariantColorScheme;
  showFullArms: boolean;
  showArmStubs: boolean;
}
export function Arms({
  emotion,
  colors,
  showFullArms,
  showArmStubs
}: ArmsProps) {
  if (!showFullArms && !showArmStubs) return null;
  if (showArmStubs) return <g className="djay-arms-stubs" data-id="element-3213" data-mp="y8kfh6yh9j7q">
        <circle cx="38" cy="125" r="8" fill={colors.armColor} data-id="element-3214" data-mp="y7j3n09n0soy" />
        <circle cx="162" cy="125" r="8" fill={colors.armColor} data-id="element-3215" data-mp="1bzpa1umznlb7" />
      </g>;
  switch (emotion) {
    case 'pointing':
      return <>
          <g className="djay-arm-left" data-id="element-3216" data-mp="172fmkkj5tjq0">
            <ellipse cx="42" cy="135" rx="14" ry="18" fill={colors.armColor} transform="rotate(15 42 135)" data-id="element-3217" data-mp="1lx3nrmhj1vzt" />
          </g>
          <g className="djay-arm-right" style={{
          transformOrigin: '150px 120px'
        }} data-id="element-3218" data-mp="37tzwq036oboh">
            <ellipse cx="165" cy="120" rx="22" ry="12" fill={colors.armColor} transform="rotate(-10 165 120)" data-id="element-3219" data-mp="3ctw0pzbvs341" />
            <path d="M175 118 L192 115" stroke={colors.armColor} strokeWidth="10" strokeLinecap="round" data-id="element-3220" data-mp="3qru0nzpgfx00" />
            <path d="M175 118 L192 115" stroke={colors.armHighlight} strokeWidth="4" strokeLinecap="round" data-id="element-3221" data-mp="3vp2jm2ifg52b" />
            <ellipse cx="170" cy="118" rx="8" ry="6" fill={colors.armHighlight} transform="rotate(-10 170 118)" data-id="element-3222" data-mp="8cjjxiyn4zud" />
          </g>
        </>;
    case 'celebrating':
    case 'excited':
    case 'proud':
      return <>
          <g className="djay-arm-left" data-id="element-3223" data-mp="2ed2ked5ch2mo">
            <ellipse cx="40" cy="90" rx="14" ry="25" fill={colors.armColor} transform="rotate(35 40 90)" data-id="element-3224" data-mp="29gu1coo10pa8" />
            <ellipse cx="32" cy="75" rx="8" ry="10" fill={colors.armHighlight} transform="rotate(35 32 75)" data-id="element-3225" data-mp="2jdyoortlyqsm" />
          </g>
          <g className="djay-arm-right" data-id="element-3226" data-mp="2t39xseghvvgi">
            <ellipse cx="160" cy="90" rx="14" ry="25" fill={colors.armColor} transform="rotate(-35 160 90)" data-id="element-3227" data-mp="2t6ebq3jri5kd" />
            <ellipse cx="168" cy="75" rx="8" ry="10" fill={colors.armHighlight} transform="rotate(-35 168 75)" data-id="element-3228" data-mp="1cps5sxdoc8h0" />
          </g>
        </>;
    case 'thinking':
      return <>
          <g className="djay-arm-left" data-id="element-3229" data-mp="3jgeomhpkr0fw">
            <ellipse cx="42" cy="135" rx="14" ry="18" fill={colors.armColor} transform="rotate(15 42 135)" data-id="element-3230" data-mp="3odev2tqc657j" />
          </g>
          <g className="djay-arm-right" data-id="element-3231" data-mp="3em0xwsluxhhk">
            <ellipse cx="135" cy="135" rx="14" ry="22" fill={colors.armColor} transform="rotate(-45 135 135)" data-id="element-3232" data-mp="3ekzfg32ihspt" />
            <ellipse cx="125" cy="120" rx="8" ry="10" fill={colors.armHighlight} transform="rotate(-45 125 120)" data-id="element-3233" data-mp="2qpekm6r8two8" />
          </g>
        </>;
    case 'surprised':
      return <>
          <g className="djay-arm-left" data-id="element-3234" data-mp="tx4kd11cfszm">
            <ellipse cx="30" cy="125" rx="18" ry="14" fill={colors.armColor} transform="rotate(-20 30 125)" data-id="element-3235" data-mp="tw1tuu7xnsk8" />
          </g>
          <g className="djay-arm-right" data-id="element-3236" data-mp="2lz5wpwe8ch9h">
            <ellipse cx="170" cy="125" rx="18" ry="14" fill={colors.armColor} transform="rotate(20 170 125)" data-id="element-3237" data-mp="2gzkvffbl7wtl" />
          </g>
        </>;
    case 'sleeping':
      return <>
          <g className="djay-arm-left" data-id="element-3238" data-mp="27385msj5y344">
            <ellipse cx="55" cy="145" rx="16" ry="12" fill={colors.armColor} transform="rotate(20 55 145)" data-id="element-3239" data-mp="22aewztkkqamr" />
          </g>
          <g className="djay-arm-right" data-id="element-3240" data-mp="1tb9zmqkr0nc6">
            <ellipse cx="145" cy="145" rx="16" ry="12" fill={colors.armColor} transform="rotate(-20 145 145)" data-id="element-3241" data-mp="1t85splfwfdht" />
          </g>
        </>;
    case 'encouraging':
      return <>
          <g className="djay-arm-left" data-id="element-3242" data-mp="19a8h3iiq277p">
            <ellipse cx="42" cy="125" rx="18" ry="22" fill={colors.armColor} transform="rotate(-20 42 125)" data-id="element-3243" data-mp="1e65yls5q1jm2" />
          </g>
          <g className="djay-arm-right" data-id="element-3244" data-mp="1o3tu4kb5iv5a">
            <ellipse cx="165" cy="135" rx="20" ry="14" fill={colors.armColor} transform="rotate(-15 165 135)" data-id="element-3245" data-mp="1o2sgc82r3ujv" />
            <ellipse cx="175" cy="130" rx="8" ry="10" fill={colors.armHighlight} transform="rotate(-15 175 130)" data-id="element-3246" data-mp="10fke5z0md1m2" />
          </g>
        </>;
    case 'happy':
    default:
      return <>
          <g className="djay-arm-left" data-id="element-3247" data-mp="cpzrp659bm81">
            <ellipse cx="42" cy="125" rx="18" ry="22" fill={colors.armColor} transform="rotate(-20 42 125)" data-id="element-3248" data-mp="coy7ab2cpndn" />
            <ellipse cx="38" cy="118" rx="8" ry="10" fill={colors.armHighlight} transform="rotate(-20 38 118)" data-id="element-3249" data-mp="3vutl656i93oa" />
          </g>
          <g className="djay-arm-right" data-id="element-3250" data-mp="9gs83jj1uswl">
            <ellipse cx="158" cy="130" rx="18" ry="22" fill={colors.armColor} transform="rotate(15 158 130)" data-id="element-3251" data-mp="3hvabv91yjmae" />
            <ellipse cx="154" cy="123" rx="8" ry="10" fill={colors.armHighlight} transform="rotate(15 154 123)" data-id="element-3252" data-mp="3ruj5g0swuyw8" />
          </g>
        </>;
  }
}